"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSplTokenInstruction = void 0;
const types_1 = require("./types");
const validators_1 = require("../../validators");
const superstruct_1 = require("superstruct");
function parseSplTokenInstruction(ix) {
    const parsed = (0, superstruct_1.create)(ix.parsed, validators_1.ParsedInfo);
    const { type: rawType, info } = parsed;
    const type = (0, superstruct_1.create)(rawType, types_1.TokenInstructionType);
    const title = types_1.IX_TITLES[type];
    const struct = types_1.IX_STRUCTS[type];
    return {
        type,
        title: title,
        info: (0, superstruct_1.create)(info, struct),
    };
}
exports.parseSplTokenInstruction = parseSplTokenInstruction;
//# sourceMappingURL=index.js.map